import Header from "./Header";
import Banner from "./Banner";
import Accordion from "./Accordion";
import Staff from "./Staff";
import Slider from "./Slider";
import AOS from "aos";
import Map from "./Map";

document.addEventListener("DOMContentLoaded", () => {
  const header = new Header();
  header.init();

  const banner = new Banner();
  banner.init();

  const accordion = new Accordion();
  accordion.init();

  const slider = new Slider();
  slider.init();

  const staff = new Staff();
  staff.init();

  const map = new Map();
  map.init();

  AOS.init({
    offset: 0,
    duration: 1250,
    easing: "ease",
    delay: 100,
    once: true,
  });
  AOS.refresh();
});

window.addEventListener("load", () => {});



// WEBPACK FOOTER //
// ./scripts/main.js